import Footer from "../components/Footer";

import Faqs from "./Faqs";
import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import usePageReady from "../../shared/usePageReady";
const metadata = {
    title: `Faq || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};
export default function FaqPage({ onPageReady }) {

    usePageReady(onPageReady);
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <>
                {/* Breadcrumb */}
                <div className="tf-breadcrumb">
                    <div className="container">
                        <ul className="breadcrumb-list">
                            <li className="item-breadcrumb">
                                <Link to={`/`} className="text">
                                    Home
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span />
                            </li>
                            <li className="item-breadcrumb">
                                <span className="text">FAQs</span>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Title Page */}
                <section className="s-title-page">
                    <div className="container">
                        <h4 className="s-title letter-0 text-center">
                            Frequently Asked Questions
                        </h4>
                    </div>
                </section>
                {/* /Title Page */}
            </>

            <Faqs />
            <Footer />
        </>
    );
}
